import styled from 'styled-components';
import { device } from '@util/commonMediaStylesUtil';

export const DashboardWrapper = styled.div`
  background-color: #eaeaf2;
  min-height: 100vh;
`;

export const CenteredSpinner = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const DashboardContainer = styled.div`
  padding: 30px;
  gap: 30px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  max-width: 1600px;
  margin: 0 auto;

  ${device.tablet`
    padding: 30px 0px; 
 `}

  ${device.phone_md`
    padding: 20px 0px; 
  `}
`;

export const DashboardTitles = styled.h1`
  height: 17px;
  font-family: EYInterstate;
  font-size: 24px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  white-space: nowrap;
  margin-top: 0px;
  margin-bottom: 0px;

  ${device.laptop_sm`
    padding-left: 10px; 
 `}
`;

export const QuarterlyMatrixTitle = styled.h2`
  height: 17px;
  font-family: EYInterstate;
  font-size: 24px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  white-space: nowrap;
  margin-top: 0px;
  margin-bottom: 0px;

  ${device.laptop_sm`
    padding-left: 10px; 
 `}
`;
